export default __webpack_public_path__ + "static/email-db189fd7a3152abf22b56273fa861312.png";